import { render } from "./InternalOrderCancerView.vue?vue&type=template&id=3cff616c&scoped=true"
import script from "./InternalOrderCancerView.vue?vue&type=script&lang=js"
export * from "./InternalOrderCancerView.vue?vue&type=script&lang=js"

import "./InternalOrderCancerView.vue?vue&type=style&index=0&id=3cff616c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cff616c"]])

export default __exports__